var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRefreshIcon24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.05 20q-3.35 0-5.7-2.325T4 12v-.175l-1.6 1.6-1.4-1.4 4-4 4 4-1.4 1.4-1.6-1.6V12q0 2.5 1.763 4.25Q9.525 18 12.05 18q.65 0 1.275-.15.625-.15 1.225-.45l1.5 1.5q-.95.55-1.95.825-1 .275-2.05.275ZM19 15.975l-4-4 1.4-1.4 1.6 1.6V12q0-2.5-1.762-4.25Q14.475 6 11.95 6q-.65 0-1.275.15-.625.15-1.225.45l-1.5-1.5q.95-.55 1.95-.825Q10.9 4 11.95 4q3.35 0 5.7 2.325T20 12v.175l1.6-1.6 1.4 1.4Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon24);
export default __webpack_public_path__ + "static/media/refresh_icon_24.5ce65741cae9c25bbeb4b0f357424af8.svg";
export { ForwardRef as ReactComponent };